import React from 'react';
import { TrendingUp, Users, Award, Target } from 'lucide-react';
import { influencerData } from '../mock';

const StatsBar = () => {
  const stats = [
    {
      icon: Users,
      label: 'Followers',
      value: influencerData.stats.followers,
      color: '#00ff41'
    },
    {
      icon: TrendingUp,
      label: 'Monthly Reach',
      value: influencerData.stats.monthlyReach,
      color: '#ff6b35'
    },
    {
      icon: Award,
      label: 'Brand Deals',
      value: influencerData.stats.brandDeals,
      color: '#00ff41'
    },
    {
      icon: Target,
      label: 'Avg. Engagement',
      value: influencerData.stats.avgEngagement,
      color: '#ff6b35'
    }
  ];

  return (
    <section className="bg-[#0a0a0a] py-16 border-y border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="text-center group hover:scale-105 transition-transform duration-300"
              >
                <div className="flex justify-center mb-3">
                  <div
                    className="p-3 rounded-lg bg-gradient-to-br from-gray-900 to-black border border-gray-800 group-hover:border-[#00ff41] transition-colors duration-300"
                  >
                    <Icon size={32} style={{ color: stat.color }} />
                  </div>
                </div>
                <div className="text-3xl sm:text-4xl font-black text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-gray-400 font-medium text-sm sm:text-base">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
